/** Input and label styles shared by the marketing field groups (semantic tokens only, 44px targets). */
export const inputClass =
  'w-full min-h-[44px] px-3 py-2.5 text-sm bg-background border border-input rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring box-border';
export const labelClass = 'block mb-1 text-xs font-medium text-foreground';
